import { IApiBaseProps } from '@common/api.models';
import { IUseFetchOptionsResult } from '@common/SelectAsyncPaginate';
import { IOption } from '@gcl/react-core';
import { UseQueryResult } from '@tanstack/react-query';

export interface IOptionFilter {
  id: number | string;
  value: string;
}

export interface IDateTimeFilter {
  from: StringFilter;
  to: StringFilter;
}

export type OptionFilter = IOptionFilter | undefined;
export type OptionsFilter = IOptionFilter[] | undefined;
export type StringFilter = string | undefined;
export type NumberFilter = number | undefined;
export type DateTimeFilter = IDateTimeFilter | undefined;
export type BooleanFilter = boolean | undefined;
export type NumberArrayFilter = number[] | undefined;
export type StringsFilter = string[] | undefined;

export enum SearchFilterType {
  TextSelect,
  Select,
  SelectWithSearch,
  CheckboxGroup,
  String,
  Number,
  DateTime,
  Boolean,
  NumberArray,
}

export interface IFilterFieldConfig {
  fieldName: string;
  displayName: string;
  type: SearchFilterType;

  disable?: boolean;
  allowMultipleSelect?: boolean;
  textSelectOptions?: string[] | IOption<string>[];
  booleanSelectOptions?: IOption<boolean>[];
  selectGroupOptionByKey?: string;
  selectDisplayFieldName?: string;
  selectKeyFieldName?: string;
  useFetchOptionsWithSearch?: (useFetchOptionsProps: any) => UseQueryResult<IUseFetchOptionsResult<any>, unknown>;
  useFetchOptionsProps?: any;
  useFetchOptions?: (props: IApiBaseProps) => UseQueryResult<IOption<any>[], unknown>;
  optionPageSize?: number;
  selectKeyFieldType?: ESelectKeyFieldType;
  shouldCastNumber?: boolean;
}

export enum ESelectKeyFieldType {
  number,
  string,
}

export type IFilter = { [key: string]: any };

export const BooleanFilterOptions: IOption<boolean>[] = [
  {
    key: 'All',
    text: 'All',
    data: undefined,
  },
  {
    key: 'Yes',
    text: 'Yes',
    data: true,
  },
  {
    key: 'No',
    text: 'No',
    data: false,
  },
];

export interface IFilterInputBaseProps<T> {
  fieldConfig: IFilterFieldConfig;
  onChange: (fieldName: string, filter: T | undefined) => void;
  filter: IFilter;
  disabled: boolean;
}
